
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface Metric {
  value: string;
  label: string;
  description?: string;
}

interface CaseMetricsProps {
  metrics: Metric[];
}

export const CaseMetrics: React.FC<CaseMetricsProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-16 fade-in">
      {metrics.map((metric, index) => (
        <Card key={index} className="glass-card overflow-hidden border-primary/10 transition-all duration-300 hover:border-primary/30 hover:shadow-lg">
          <CardContent className="p-6">
            <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
              {metric.value}
            </div>
            <div className="text-lg font-medium mb-2">{metric.label}</div>
            {metric.description && (
              <p className="text-muted-foreground text-sm">{metric.description}</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
